import type { ButtonListObject } from '@/scenes/Editor/components/FloatingInspectorButton/SharedComponents/Popover/ButtonsListPopover'
import type { PopoverWidthType } from '@/scenes/Editor/components/FloatingInspectorButton/SharedComponents/Popover/WrapPopover'
import type { SuggestionButtonPopover } from '@/scenes/Editor/components/EditWithAI/components/suggestedButtonSets'

type AspectRatioListPopoverParams = {
  title: string
  items: ButtonListObject[]
  width?: PopoverWidthType
}

export function createAspectRatioListPopover({
  title,
  items,
  width,
}: AspectRatioListPopoverParams): SuggestionButtonPopover {
  return {
    designType: 'list_white',
    title,
    ...(width != null ? { width } : {}),
    minWidth: 250,
    maxWidth: 300,
    items,
  }
}
